<template>
    <v-card class="pb-3 pt-1 px-2" style="background-color:#f1ffdc">
        <v-progress-linear
            v-if="loading"
            :indeterminate="true"
            color="success"
        ></v-progress-linear>
        <div v-if="!loading">
            <v-layout
                v-if="!calls.length"
                justify-center
                align-center
                class="my-3 headline"
            >
                No IVR Calls
            </v-layout>
            <div v-if="calls.length">
                <v-card
                    class="pb-4 pt-2 px-3 my-3"
                    v-for="(call, index) in calls"
                >
                    <v-layout row class="px-3 pb-1 pt-3">
                        <div class="font-weight-medium mr-2 width-200">
                            Date:
                        </div>
                        <div>
                            {{ call.date | time }}
                        </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1" v-if="call.callerID">
                        <div class="font-weight-medium mr-2 width-200">
                            Caller ID:
                        </div>
                        <div>
                            {{ formatPhoneNumber(call.callerID) }}
                        </div>
                    </v-layout>

                    <v-btn
                        class="mb-0"
                        @click="openActions(call)"
                        color="success"
                        outline
                        small
                        >{{
                            call.showActions ? "Hide Actions" : "Show Actions"
                        }}</v-btn
                    >

                    <div class="mt-4" v-if="call.showActions">
                        <div
                            class="dinner-ivr-detail-text px-3"
                            v-for="(action, index) in call.actions"
                        >
                            <div class="layout row ">
                                <div class="mr-1  width-250">
                                    {{ action.date }}
                                </div>
                                <div>{{ action.title }}</div>
                            </div>
                            <div class="layout row wrap mb-1 text--disabled">
                                <div>
                                    {{ action.description }}
                                </div>
                            </div>
                            <v-divider
                                class="py-2 mb-1"
                                v-if="index + 1 < call.actions.length"
                            ></v-divider>
                        </div>
                    </div>
                </v-card>

                <v-layout justify-center>
                    <v-pagination
                        v-model="pagination.page"
                        :length="pages"
                        :total-visible="7"
                        v-on:input="setPagianation"
                    ></v-pagination>
                </v-layout>
            </div>
        </div>
    </v-card>
</template>
<script>
import { formatPhoneNumber } from "../../utils/helpers.js";
import moment from "moment";

export default {
    props: {},
    data() {
        return {
            loading: true,
            ivrCalls: [],
            calls: [],
            pagination: {
                totalCount: 0,
                rowsPerPage: 5,
                page: 1,
            },

            callActionsMap: new Map([
                ["LOOKUP_PHONE", "Lookup callerID"],
                ["VALIDATE_PHONE", "Validate Phone"],
                ["VALIDATE_PIN", "Validate Pin / Load Account"],
                ["RECOVER_PIN", "Recover Pin"],
                ["VALIDATE_CARD", "Entered Credit Card"],
                ["VALIDATE_SAVED_CARD", "Validate Saved Card"],
                ["VALIDATE_EXP", "Validate Expiration Date"],
                ["PLAY_MISSING_IMMUNIZATIONS", "Play Missing Immunizations"],
                ["PLAY_REGISTRATION_STATUS", "Play Registration Status"],
                ["TUITION_BALANCE_DETAILS", "Play Tuition Balance Details"],
                [
                    "TRANSPORTATION_BALANCE_DETAILS",
                    "Play Transportation Balance Details",
                ],
                ["PLAY_SAVED_CARDS", "Play Saved Cards List"],
                ["PAYMENT_PLAN_DETAILS", "Play Payment Plan Details"],
                ["START_PAYMENT_PROCESS", "Start Payment Process"],
                ["START_AUTOPAYSETUP_PROCESS", "Start Auto Pay Setup Process"],
                ["PAYMENT_PROCESSING", "Payment Procssing"],
                ["CARD_PROCESSED_SUCCESS", "Payment Processed Successfully"],
                ["CARD_PROCESSED_FAILED", "Payment Failed"],
                ["AUTOPAY_SETUP_FAILED", "Auto Pay Setup Failed"],
                ["AUTOPAY_SETUP_SUCCESS", "Auto Pay Setup Successfull"],
                ["CONTACT_US", "Contact Us"],
                ["HANGUP", "Hangup"],
            ]),
        };
    },
    async created() {
        await this.loadIvrCalls();
    },
    mounted() {},
    beforeDestroy() {},
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(this.ivrCalls.length / this.pagination.rowsPerPage)
                : 0;
        },
    },
    methods: {
        async loadIvrCalls() {
            const ivrCalls = await this.$http.get(
                "api/iVRCalls/getForAccount?accountID=" + this.$route.params.id
            );
            this.loading = false;
            this.ivrCalls = ivrCalls.map((call) => {
                call.actions = [];
                call.showActions = false;

                return call;
            });
            this.calls = ivrCalls.slice(0, 5);
            this.pagination.totalCount = ivrCalls.length;
        },
        async openActions(call) {
            if (call.showActions) {
                call.showActions = false;
                return;
            }

            call.showActions = true;

            if (!call.actions.length) {
                const actions = await this.$http.get(
                    "api/broadcast/getCallActivity?callUUID=" + call.call_UUID
                );

                call.actions = actions.map((action) => {
                    action.date = moment(action.date).format("LTS");
                    action.title =
                        this.callActionsMap.get(action.eventType) ||
                        action.eventType;
                    action.description = this.getActionDescription(action);

                    return action;
                });
            }
        },
        getActionDescription(action) {
            if (
                [
                    "START_PAYMENT_PROCESS",
                    "START_AUTOPAYSETUP_PROCESS",
                ].includes(action.eventType)
            )
                return null;

            const inputActions = [
                "LOOKUP_PHONE",
                "VALIDATE_PHONE",
                "VALIDATE_PIN",
                "VALIDATE_CARD",
                "VALIDATE_EXP",
                "VALIDATE_SAVED_CARD",
            ];

            if (inputActions.includes(action.eventType)) {
                return action.inputDigits + " | " + action.response;
            }

            if (action.eventType == "CARD_PROCESSED_SUCCESS") {
                const pecies = action.response.split("|");
                const status = pecies
                    .find((p) => p.startsWith("status"))
                    .substring(7);
                const amount = pecies
                    .find((p) => p.startsWith("amount"))
                    .substring(7);

                return "$" + amount + " | " + status;
            }

            return action.response;
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.calls = this.ivrCalls.slice(
                number,
                number + this.pagination.rowsPerPage
            );
        },
        formatPhoneNumber(number) {
            return formatPhoneNumber(number);
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
    },
};
</script>
<style>
.ivr-detail-text {
    font-size: 16px;
    font-weight: 400;
}
</style>
